import { useCallback, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import type { Conversation } from '../api/client'

/**
 * Opens a conversation that may not exist yet (a shift's team chat, an event channel,
 * a first direct message): the server creates it on the way, then we go there.
 */
export function useOpenConversation() {
  const navigate = useNavigate()
  const [opening, setOpening] = useState(false)
  const [error, setError] = useState<string | null>(null)

  const open = useCallback(
    async (load: () => Promise<Conversation>) => {
      setOpening(true)
      setError(null)
      try {
        const conversation = await load()
        navigate(`/messages/${conversation.id}`)
      } catch (err: any) {
        setError(err?.message || 'Error')
      } finally {
        setOpening(false)
      }
    },
    [navigate],
  )

  return { open, opening, error }
}
